export * from './authentication.service';
export * from './school.service';
export * from './attend-student.service';
export * from './student.service';
export * from './attend-staff.service';
export * from './staff.service';



// WEBPACK FOOTER //
// /home/hihoo/ibilling/attendence/public/src/app/Service/index.ts